import CopyIcon from 'assets/ver2/icons/copy-outline-icon.svg';
import useDebounceCallback from 'hooks/useDebounceCallback';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { useRef, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const FormInputCopy = ({
  value,
  isModal,
  isHideFormLabel,
  ShareButton = () => null,
  styles = {},
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const [isShowCopySuccess, setShowCopySuccess] = useState(false);
  const target = useRef(null);

  const { debounce } = useDebounceCallback(() => {
    handleCopySuccess();
  }, 0.5);

  const handleCopySuccess = () => {
    setShowCopySuccess(false);
  };

  const handleCopy = () => {
    if ('clipboard' in navigator) {
      navigator.clipboard.writeText(value);
    }

    setShowCopySuccess(true);

    debounce();
  };

  const renderFormLabel = () => {
    if (isHideFormLabel) return null;
    return <FormLabel>{t('label_share_desc')}</FormLabel>;
  };

  const renderFormInputCopy = () => {
    if (isModal || !isDesktop)
      return (
        <FormInputWrapMobile>
          <FormControl type="text" value={value} readOnly={true} />
          <CopyIconMobileStyled
            src={CopyIcon}
            width={24}
            height={24}
            alt=""
            onClick={handleCopy}
          />
        </FormInputWrapMobile>
      );
    return (
      <FormInputWrap>
        <FormControl type="text" value={value} readOnly={true} />
        <CopyIconStyled
          src={CopyIcon}
          width={24}
          height={24}
          alt=""
          onClick={handleCopy}
        />
        <ShareButton />
      </FormInputWrap>
    );
  };
  return (
    <>
      <style>
        {`
          #copy-trigger {
            width: 100px !important;
            min-height: 100px;
            inset: auto auto calc(50% - 50px) calc(50% - 50px) !important;
            transform: translate(calc(50% - 50px), calc(50% - 50px)) !important;
            opacity: 1!important;
            box-shadow: var(--ds-bs-4);
            border-radius: 24px;
          }
          .tooltip-inner {
            padding: 6px!important;
            text-align: center!important;

            height: 100px!important;
            background: #fff;
            font-size: 16px!important;
            color: #000!important;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            text-transform: uppercase!important;
          }
          .tooltip-arrow::before {
            display: none!important;
          }
        `}
      </style>
      <Overlay target={target.current} show={isShowCopySuccess} placement="top">
        <Tooltip id="copy-trigger">{t('label_copied')}</Tooltip>
      </Overlay>
      <FormGroupStyled ref={target} style={styles}>
        {renderFormLabel()}
        {renderFormInputCopy()}
      </FormGroupStyled>
    </>
  );
};

const FormGroupStyled = styled(Form.Group)`
  position: relative;
`;

const FormLabel = styled(Form.Label)`
  ${paragraphMixin};
  font-weight: 500;
  text-align: left;

  margin: 0;
  margin-bottom: 16px;
`;

const FormInputWrapMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
const FormInputWrap = styled.div`
  width: calc(100% - 200px - 12px);
  margin-right: 12px;
  float: left;
  & img {
    position: absolute;
    top: 7px;
    left: calc(100% - 200px - 12px - 36px - 8px);
  }
`;

const FormControl = styled(Form.Control)`
  ${paragraphMixin};
  font-weight: 500;
  height: 50px;
  border: none;
  border-radius: 8px;
  padding-inline: 10px;
  background: #f3f4f6;
  text-overflow: ellipsis;

  &:focus {
    background: #f3f4f6;
    border: 1px solid var(--ds-c-grey-dark) !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &[readonly] {
    background: #f3f4f6;
  }

  &::placeholder {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: var(--ds-c-grey-hover);
  }
`;

const CopyIconMobileStyled = styled.img`
  background: #fff;
  border: 1px solid var(--ds-c-blue-hyperlink-default);
  border-radius: 8px !important;

  width: 50px !important;
  height: 50px;
  padding: 13px;
  cursor: pointer;
`;
const CopyIconStyled = styled.img`
  background: #fff;
  border: 1px solid var(--ds-c-blue-hyperlink-default);
  border-radius: 8px;

  width: 36px;
  height: 36px;
  padding: 6px;
  cursor: pointer;
`;

export default FormInputCopy;
